import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import _ from "lodash";

const Error = () => {
  useEffect(() => {
    document.documentElement.scrollTop = 0;
  }, []);

  return (
    <div>
      <Helmet>
        <title>IMPACT Family</title>
        <meta name="title" content="Impact Family" />
        <meta name="description" content="Impact Family" />
        <meta name="keyword" content="" />
        <meta property="og:title" content="Impact Family" />
        <meta property="og:description" content="Impact Family" />
        <meta property="og:image" content="" />
        <meta property="og:url" content="" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Impact Family" />
      </Helmet>
      <style>
        {`
          .bContent {
            background-color: #F6F8FA;
            border-radius: 12px;
            padding: 24px 16px;
          }
        `}
      </style>
      <div id="pagePolicy-Terms">
        <main>
          <div className="wrapContent">
            <section id="pContent">
              <div className="bContent">
                <h1 style={{ margin: "0px" }}>
                  ขออภัย กรุณาเปิดใน LINE บนมือถือ..
                </h1>
              </div>
            </section>
          </div>
        </main>
      </div>
    </div>
  );
};

export default Error;
